import { useContext } from "react";
import WhitelabelContext from "../contexts/WhitelabelContext";

export const useWhitelabelConfig = () => {
  const context = useContext(WhitelabelContext);
  if (!context) {
    throw new Error("useWhitelabelConfig deve ser usado dentro de WhitelabelProvider");
  }
  return context.config;
};

export const useWhitelabelBranding = () => {
  const context = useContext(WhitelabelContext);
  if (!context) {
    throw new Error("useWhitelabelBranding deve ser usado dentro de WhitelabelProvider");
  }
  return {
    branding: context.branding,
    isWhitelabel: context.isWhitelabel,
    brandName: context.brandName,
    organizationName: context.organizationName
  };
};

export const useWhitelabelColors = () => {
  const context = useContext(WhitelabelContext);
  if (!context) {
    throw new Error("useWhitelabelColors deve ser usado dentro de WhitelabelProvider");
  }
  return context.colors;
};

export const useWhitelabelLogos = () => {
  const context = useContext(WhitelabelContext);
  if (!context) {
    throw new Error("useWhitelabelLogos deve ser usado dentro de WhitelabelProvider");
  }
  return context.logos;
};

export const useWhitelabelLoading = () => {
  const context = useContext(WhitelabelContext);
  if (!context) {
    throw new Error("useWhitelabelLoading deve ser usado dentro de WhitelabelProvider");
  }
  return {
    isLoading: context.isLoading,
    error: context.error,
    refresh: context.refresh,
    clearCache: context.clearCache
  };
};